import {
  SUPABASE_URL as _supabaseUrl,
  SUPABASE_URL_ANDROID_DEVICE as _supabaseUrlAndroidDevice,
  SUPABASE_ANON_KEY as _supabaseAnonKey,
  SUPABASE_AUTH_REDIRECT_URL as _authRedirect,
} from '@env';
import {NativeModules, Platform} from 'react-native';

const AUTH_ENV_DEBUG = __DEV__;

function getDevServerHost() {
  // On native dev builds, try multiple RN native hints for Metro host.
  const scriptUrl = NativeModules?.SourceCode?.scriptURL;
  const serverHostRaw = NativeModules?.PlatformConstants?.ServerHost;
  if (AUTH_ENV_DEBUG) {
    console.log('[auth-env] SourceCode.scriptURL =', scriptUrl ?? '<empty>');
    console.log('[auth-env] PlatformConstants.ServerHost =', serverHostRaw ?? '<empty>');
  }
  if (scriptUrl) {
    const match = String(scriptUrl).match(/^[a-z]+:\/\/([^/:]+)/i);
    const host = match?.[1] ?? '';
    if (AUTH_ENV_DEBUG) {
      console.log('[auth-env] Extracted Metro host (scriptURL) =', host || '<empty>');
    }
    if (host) {
      return host;
    }
  }

  // Android RN commonly exposes "ip:port" here (example: 192.168.1.42:8081).
  const host = String(serverHostRaw || '').split(':')[0];
  if (AUTH_ENV_DEBUG) {
    console.log('[auth-env] Extracted Metro host (ServerHost) =', host || '<empty>');
  }
  return host;
}

function resolveSupabaseUrl(url) {
  if (AUTH_ENV_DEBUG) {
    console.log('[auth-env] Input SUPABASE_URL =', url ?? '<empty>');
    console.log('[auth-env] Platform/dev =', Platform.OS, __DEV__);
  }
  if (!url || Platform.OS !== 'android' || !__DEV__) {
    if (AUTH_ENV_DEBUG) {
      console.log('[auth-env] Keeping URL (non-android/dev guard)');
    }
    return url;
  }
  // Android emulator cannot resolve localhost to host machine.
  const androidLocalUrl = url
    .replace('://localhost', '://10.0.2.2')
    .replace('://127.0.0.1', '://10.0.2.2');
  if (AUTH_ENV_DEBUG && androidLocalUrl !== url) {
    console.log('[auth-env] Rewrote localhost URL for Android emulator =', androidLocalUrl);
  }

  // 10.0.2.2 is Android emulator-only. On physical USB devices, replace with Metro host IP.
  if (!androidLocalUrl.includes('10.0.2.2')) {
    if (AUTH_ENV_DEBUG) {
      console.log('[auth-env] Keeping URL (no 10.0.2.2 to replace)');
    }
    return androidLocalUrl;
  }
  if (_supabaseUrlAndroidDevice?.trim?.()) {
    if (AUTH_ENV_DEBUG) {
      console.log(
        '[auth-env] Using SUPABASE_URL_ANDROID_DEVICE override =',
        _supabaseUrlAndroidDevice,
      );
    }
    return _supabaseUrlAndroidDevice;
  }
  const host = getDevServerHost();
  if (!host || host === '10.0.2.2' || host === 'localhost' || host === '127.0.0.1') {
    if (AUTH_ENV_DEBUG) {
      console.log('[auth-env] Keeping URL (host invalid for replacement) =', host || '<empty>');
    }
    return androidLocalUrl;
  }
  const resolved = androidLocalUrl.replace('10.0.2.2', host);
  if (AUTH_ENV_DEBUG) {
    console.log('[auth-env] Resolved SUPABASE_URL =', resolved);
  }
  return resolved;
}

// Named re-exports become `export { undefined }` when vars are missing from .env (invalid).
export const SUPABASE_URL = resolveSupabaseUrl(_supabaseUrl);
export const SUPABASE_ANON_KEY = _supabaseAnonKey;
/** Optional. Password-reset email link; whitelist in Supabase Auth URL settings. */
export const SUPABASE_AUTH_REDIRECT_URL = _authRedirect;

if (AUTH_ENV_DEBUG) {
  console.log('[auth-env] Final exported SUPABASE_URL =', SUPABASE_URL ?? '<empty>');
}
